import { ChemistriesReportPage } from "./ChemistriesReportPage";

type Props = {};
const ChemistriesReport = (props: Props) => {
	return <ChemistriesReportPage />;
};
export default ChemistriesReport;
